<template>
    <aside>
        <header class="mb-3 d-flex">
           <search-input v-model="params.search" class="flex-grow-1"/>

            <b-button
                :to="{ name: 'customers.create' }"
                :title="$t('Create new customer')"
                variant="primary"
                class="ml-3"
            >
                <fa icon="plus" :title="$t('Create new customer')" />
            </b-button>
        </header>

        <nav>
            <b-list-group tag="ul">
                <b-list-group-item
                    v-for="customer in items"
                    :key="customer.id"
                    :to="{ name: 'customers.edit', params: { customerId: customer.id } }"
                    class="flex-column align-items-start mb-1"
                    tag="li"
                >
                    <div class="d-flex w-100 justify-content-between">
                        <h2 class="h5 mb-1">
                            {{ customer.name }}
                        </h2>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </nav>

        <b-pagination
            v-if="showPagination"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            limit="3"
        />

        <div v-show="pending" class="text-center mt-1">
            <b-spinner/>
        </div>
    </aside>
</template>
<script>
    import fetchPaginatedData from '@/mixins/fetchPaginatedData';
    import SearchInput from "@/components/SeachInput";

    export default {
    name: 'Customers',
    components: {SearchInput},
    mixins: [fetchPaginatedData],
    computed: {
        apiUrl() {
            return '/api/customers'
        }
    },

    created() {
        let _this = this;

        this.$root.$on('created::customer', function(data) {
            _this.items.unshift(data);
            _this.totalRows += 1;
            if (_this.items.length > _this.perPage) {
                _this.items.pop();
            }
        });

        this.$root.$on('updated::customer', function(data) {
            let index = _this.items.findIndex(({id}) => id === data.id);
            _this.items.splice(index, 1, data);
        });

        this.$root.$on('deleted::customer', function(userId) {
            let index = _this.items.findIndex(({id}) => id === userId);
            _this.items.splice(index, 1);
        });
    },
}
</script>
